import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_vuesocialsharingplugin_61df2d9f from 'nuxt_plugin_vuesocialsharingplugin_61df2d9f' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_image_7e5c3ea1 from 'nuxt_plugin_image_7e5c3ea1' // Source: ./image.js (mode: 'all')
import nuxt_plugin_plugin_329d0989 from 'nuxt_plugin_plugin_329d0989' // Source: ./nuxt-speedkit/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_2dd2d54e from 'nuxt_plugin_cookieuniversalnuxt_2dd2d54e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_d9557cb4 from 'nuxt_plugin_axios_d9557cb4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_077bd331 from 'nuxt_plugin_deviceplugin_077bd331' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_handleerrors_02fc14a8 from 'nuxt_plugin_handleerrors_02fc14a8' // Source: ../plugins/handle_errors (mode: 'all')
import nuxt_plugin_fallbackimage_19570136 from 'nuxt_plugin_fallbackimage_19570136' // Source: ../plugins/directives/fallback-image (mode: 'all')
import nuxt_plugin_resize_30106e69 from 'nuxt_plugin_resize_30106e69' // Source: ../plugins/directives/resize (mode: 'client')
import nuxt_plugin_scroll_31a8b882 from 'nuxt_plugin_scroll_31a8b882' // Source: ../plugins/directives/scroll (mode: 'client')
import nuxt_plugin_vuestickydirective_107c77c7 from 'nuxt_plugin_vuestickydirective_107c77c7' // Source: ../plugins/directives/vue-sticky-directive (mode: 'client')
import nuxt_plugin_vtooltip_74057214 from 'nuxt_plugin_vtooltip_74057214' // Source: ../plugins/v-tooltip (mode: 'all')
import nuxt_plugin_pixel_3204e7e4 from 'nuxt_plugin_pixel_3204e7e4' // Source: ../plugins/mixins/facebook/pixel (mode: 'client')
import nuxt_plugin_vuecontentplaceholders_2d242d91 from 'nuxt_plugin_vuecontentplaceholders_2d242d91' // Source: ../plugins/vue-content-placeholders (mode: 'all')
import nuxt_plugin_constants_56a5fa99 from 'nuxt_plugin_constants_56a5fa99' // Source: ../plugins/constants (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_route_338f5eda from 'nuxt_plugin_route_338f5eda' // Source: ../plugins/route (mode: 'client')
import nuxt_plugin_vuexinitorderclient_4c760b3c from 'nuxt_plugin_vuexinitorderclient_4c760b3c' // Source: ../plugins/vuex-init-order-client (mode: 'client')
import nuxt_plugin_vmask_3801a64e from 'nuxt_plugin_vmask_3801a64e' // Source: ../plugins/v-mask (mode: 'client')
import nuxt_plugin_cordial_1fb78dc0 from 'nuxt_plugin_cordial_1fb78dc0' // Source: ../plugins/cordial (mode: 'client')
import nuxt_plugin_facebookpixel_58a6ac96 from 'nuxt_plugin_facebookpixel_58a6ac96' // Source: ../plugins/facebook-pixel (mode: 'client')
import nuxt_plugin_pinterestpixel_303c4c5d from 'nuxt_plugin_pinterestpixel_303c4c5d' // Source: ../plugins/pinterest-pixel (mode: 'client')
import nuxt_plugin_vuecurrencyinput_76959c2b from 'nuxt_plugin_vuecurrencyinput_76959c2b' // Source: ../plugins/vue-currency-input (mode: 'all')
import nuxt_plugin_vueinstantsearch_9a9113e8 from 'nuxt_plugin_vueinstantsearch_9a9113e8' // Source: ../plugins/vue-instantsearch (mode: 'all')
import nuxt_plugin_searchinsights_dcea07ac from 'nuxt_plugin_searchinsights_dcea07ac' // Source: ../plugins/search-insights (mode: 'client')
import nuxt_plugin_ga4datastream_2ce00a1a from 'nuxt_plugin_ga4datastream_2ce00a1a' // Source: ../plugins/ga4-data-stream (mode: 'client')
import nuxt_plugin_vuesocialsharing_dccf00ce from 'nuxt_plugin_vuesocialsharing_dccf00ce' // Source: ../plugins/vue-social-sharing (mode: 'client')
import nuxt_plugin_honeybadger_5c9d30b9 from 'nuxt_plugin_honeybadger_5c9d30b9' // Source: ../../shared/plugins/honeybadger (mode: 'client')
import nuxt_plugin_amplify_9b2e4ac4 from 'nuxt_plugin_amplify_9b2e4ac4' // Source: ../plugins/amplify (mode: 'all')
import nuxt_plugin_fingerprint_6f1927ae from 'nuxt_plugin_fingerprint_6f1927ae' // Source: ../plugins/fingerprint (mode: 'client')
import nuxt_plugin_googleonetap_fe77e5c4 from 'nuxt_plugin_googleonetap_fe77e5c4' // Source: ../plugins/google-one-tap (mode: 'client')
import nuxt_plugin_klaviyo_7e39001a from 'nuxt_plugin_klaviyo_7e39001a' // Source: ../plugins/klaviyo (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"debounceWait":250,"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"src":"https:\u002F\u002Fwww.dwin1.com\u002F58771.js","type":"text\u002Fjavascript","defer":true},{"src":"https:\u002F\u002Fcdn.attn.tv\u002Fsandn\u002Fdtag.js","defer":true}],"title":"Scout & Nimble","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"content":"#ffffff","name":"msapplication-TileColor"},{"content":"\u002Ffavicons\u002Fms-icon-144x144.png","name":"msapplication-TileImage"},{"content":"#ffffff","name":"theme-color"}],"link":[{"rel":"preload","href":"\u002Ffonts\u002Fopensans.ttf","type":"font\u002Fttf","as":"font","importance":"high","crossorigin":"anonymous"},{"rel":"preconnect","href":undefined},{"href":"\u002Ffavicons\u002Fapple-icon-57x57.png","rel":"apple-touch-icon","sizes":"57x57"},{"href":"\u002Ffavicons\u002Fapple-icon-60x60.png","rel":"apple-touch-icon","sizes":"60x60"},{"href":"\u002Ffavicons\u002Fapple-icon-72x72.png","rel":"apple-touch-icon","sizes":"72x72"},{"href":"\u002Ffavicons\u002Fapple-icon-76x76.png","rel":"apple-touch-icon","sizes":"76x76"},{"href":"\u002Ffavicons\u002Fapple-icon-114x114.png","rel":"apple-touch-icon","sizes":"114x114"},{"href":"\u002Ffavicons\u002Fapple-icon-120x120.png","rel":"apple-touch-icon","sizes":"120x120"},{"href":"\u002Ffavicons\u002Fapple-icon-144x144.png","rel":"apple-touch-icon","sizes":"144x144"},{"href":"\u002Ffavicons\u002Fapple-icon-152x152.png","rel":"apple-touch-icon","sizes":"152x152"},{"href":"\u002Ffavicons\u002Fapple-icon-180x180.png","rel":"apple-touch-icon","sizes":"180x180"},{"href":"\u002Ffavicons\u002Fandroid-icon-192x192.png","rel":"icon","sizes":"192x192","type":"image\u002Fpng"},{"href":"\u002Ffavicons\u002Ffavicon-32x32.png","rel":"icon","sizes":"32x32","type":"image\u002Fpng"},{"href":"\u002Ffavicons\u002Ffavicon-96x96.png","rel":"icon","sizes":"96x96","type":"image\u002Fpng"},{"href":"\u002Ffavicons\u002Ffavicon-16x16.png","rel":"icon","sizes":"16x16","type":"image\u002Fpng"},{"href":"\u002Ffavicons\u002Fmanifest.json","rel":"manifest"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_vuesocialsharingplugin_61df2d9f === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_61df2d9f(app.context, inject)
  }

  if (typeof nuxt_plugin_image_7e5c3ea1 === 'function') {
    await nuxt_plugin_image_7e5c3ea1(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_329d0989 === 'function') {
    await nuxt_plugin_plugin_329d0989(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2dd2d54e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2dd2d54e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_d9557cb4 === 'function') {
    await nuxt_plugin_axios_d9557cb4(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_077bd331 === 'function') {
    await nuxt_plugin_deviceplugin_077bd331(app.context, inject)
  }

  if (typeof nuxt_plugin_handleerrors_02fc14a8 === 'function') {
    await nuxt_plugin_handleerrors_02fc14a8(app.context, inject)
  }

  if (typeof nuxt_plugin_fallbackimage_19570136 === 'function') {
    await nuxt_plugin_fallbackimage_19570136(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_resize_30106e69 === 'function') {
    await nuxt_plugin_resize_30106e69(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scroll_31a8b882 === 'function') {
    await nuxt_plugin_scroll_31a8b882(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestickydirective_107c77c7 === 'function') {
    await nuxt_plugin_vuestickydirective_107c77c7(app.context, inject)
  }

  if (typeof nuxt_plugin_vtooltip_74057214 === 'function') {
    await nuxt_plugin_vtooltip_74057214(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pixel_3204e7e4 === 'function') {
    await nuxt_plugin_pixel_3204e7e4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecontentplaceholders_2d242d91 === 'function') {
    await nuxt_plugin_vuecontentplaceholders_2d242d91(app.context, inject)
  }

  if (typeof nuxt_plugin_constants_56a5fa99 === 'function') {
    await nuxt_plugin_constants_56a5fa99(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_route_338f5eda === 'function') {
    await nuxt_plugin_route_338f5eda(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexinitorderclient_4c760b3c === 'function') {
    await nuxt_plugin_vuexinitorderclient_4c760b3c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmask_3801a64e === 'function') {
    await nuxt_plugin_vmask_3801a64e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cordial_1fb78dc0 === 'function') {
    await nuxt_plugin_cordial_1fb78dc0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebookpixel_58a6ac96 === 'function') {
    await nuxt_plugin_facebookpixel_58a6ac96(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pinterestpixel_303c4c5d === 'function') {
    await nuxt_plugin_pinterestpixel_303c4c5d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecurrencyinput_76959c2b === 'function') {
    await nuxt_plugin_vuecurrencyinput_76959c2b(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinstantsearch_9a9113e8 === 'function') {
    await nuxt_plugin_vueinstantsearch_9a9113e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_searchinsights_dcea07ac === 'function') {
    await nuxt_plugin_searchinsights_dcea07ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ga4datastream_2ce00a1a === 'function') {
    await nuxt_plugin_ga4datastream_2ce00a1a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesocialsharing_dccf00ce === 'function') {
    await nuxt_plugin_vuesocialsharing_dccf00ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_honeybadger_5c9d30b9 === 'function') {
    await nuxt_plugin_honeybadger_5c9d30b9(app.context, inject)
  }

  if (typeof nuxt_plugin_amplify_9b2e4ac4 === 'function') {
    await nuxt_plugin_amplify_9b2e4ac4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fingerprint_6f1927ae === 'function') {
    await nuxt_plugin_fingerprint_6f1927ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleonetap_fe77e5c4 === 'function') {
    await nuxt_plugin_googleonetap_fe77e5c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_klaviyo_7e39001a === 'function') {
    await nuxt_plugin_klaviyo_7e39001a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
